export default __webpack_public_path__ + "static/media/logo.154fc0f1.png";